import {websiteSvg as Icon__small__websiteSvg} from '../Icon__small/Icon__small--website.js';
import {websiteSvg as Icon__xsmall__websiteSvg} from '../Icon__xsmall/Icon__xsmall--website.js';

export var website = {
  name: 'website',
  category: 'icon',
  colorable: true,
  svg: Icon__small__websiteSvg,
  alt: {
    Icon__small: Icon__small__websiteSvg,
    Icon__xsmall: Icon__xsmall__websiteSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
